import React from 'react'

// Components
import BannerDefault from 'components/flex/Banner/BannerDefault'
import BannerLanding from 'components/flex/Banner/BannerLanding'
import BannerVideo from 'components/flex/Banner/BannerVideo'

export interface BannerProps {
  // eslint-disable-next-line camelcase
  fields: GatsbyTypes.WpPost_Flexcontent_Flex_Banner
  location?: any
}

interface BannersProps {
  [key: string]: any
}

const BannerShell: React.FC<BannerProps> = ({ fields, location = {} }) => {
  const banners: BannersProps = {
    default: BannerDefault,
    landing: BannerLanding,
    video: BannerVideo,
  }

  if (!fields.styletype || !banners[fields.styletype]) {
    return null
  }

  const Component = banners[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default BannerShell
